export const FIELD_TO_GROUP_TITLE_KEY: Record<string, string> = {
  anomalyTypeGroup: 'alertsManagerWidget:alertRules.columnTitle.anomalyTypeGroup',
  parameterGroup: 'alertsManagerWidget:alertRules.columnTitle.parameterGroup',
  holeDepthInterval: 'alertsManagerWidget:alertRules.columnTitle.holeDepth',
  depthInterval: 'alertsManagerWidget:alertRules.columnTitle.depth',
  min: 'alertsManagerWidget:alertRules.columnTitle.min',
  max: 'alertsManagerWidget:alertRules.columnTitle.max',
  diff: 'alertsManagerWidget:alertRules.columnTitle.diff',
} as const;
